export default __webpack_public_path__ + "static/media/outro-img-bear-1.7f5024a3.png";